var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.9994 73.3332C58.3327 73.3332 73.3327 58.3332 73.3327 39.9998C73.3327 21.6665 58.3327 6.6665 39.9994 6.6665C21.666 6.6665 6.66602 21.6665 6.66602 39.9998C6.66602 58.3332 21.666 73.3332 39.9994 73.3332Z",
    stroke: "#07B22D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.834 40.0002L35.2673 49.4336L54.1673 30.5669",
    stroke: "#07B22D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheckIcon);
export default __webpack_public_path__ + "static/media/round-check-icon.60621130c9dcec1b2a7c1908de5680f1.svg";
export { ForwardRef as ReactComponent };